import lazysizes from 'lazysizes'

const options = {"plugins":{"blurUp":true}}

Object.assign(lazysizes.cfg, options)
